import { useState, useCallback, useEffect } from "react";
import {
  addEdge,
  useNodesState,
  useEdgesState,
  ReactFlowProvider,
} from "reactflow";
import { Modal, Paper, Typography, Button, IconButton, Box, styled } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"
import { FlowList } from "./FlowList";
import { FlowActions } from './FlowActions';
import { Flow } from './Flow';
import { PropertiesPanel } from '../PropertiesPanel/PropertiesPanel';
import "reactflow/dist/style.css";
import { updateFlowInAPI, createFlowVersionInAPI, fetchFlowDetailFromAPI } from '../../Redux/FlowDucks';
import { useDispatch } from 'react-redux';
import { nodeTypes } from './CustomNodes';
import { edgeTypes } from './CustomEdges';
import { Toast } from "react-bootstrap";
import { compileFlowAPI } from '../../Redux/FlowDucks'
import { ConfigurationPanel } from "./ConfigurationPanel";
import { FlowSaveConfirmModal } from "./FlowSaveConfirmModal";
import { diffFlow } from "../../Utilities/flowDiff";

// Estilos personalizados
const TerminalPaper = styled(Paper)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "800px",
  maxWidth: "90%",
  //backgroundColor: "#1a1b1e",
  border: "1px solid #2f3336",
  boxShadow: theme.shadows[24],
  outline: "none",
}))

const TerminalHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 16px",
  //borderBottom: "1px solid #2f3336",
})

const TerminalContent = styled(Box)({
  marginLeft: "8px",
  marginRight: "8px",
  borderRadius: "8px",
  minHeight: "300px",
  padding: "16px",
  fontFamily: 'Consolas, Monaco, "Courier New", monospace',
  fontSize: "14px",
  backgroundColor: "#1a1b1e",
})

const TerminalFooter = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  gap: "8px",
  padding: "12px 16px",
  //borderTop: "1px solid #2f3336",
})


const ALL_STEPS = [
  { text: "--- Compilacion de Flujo Seleccionado ---", type: "output" },
  { text: "Se han encontrado {nodes} Nodos y {edges} Relaciones ¿Desea iniciar proceso de Compilación?", type: "command" },
  { text: "Revisando Nodos de Incio", type: "output" },
  { text: "StarterNodes#ok", type: "success" },
  { text: "Revisando Nodos de Cierre", type: "command" },
  { text: "EndingNodes#ok", type: "success" },
  { text: "Revisando Nodos Aislados", type: "command" },
  { text: "IsolatedNodes#ok", type: "success" },
  // { text: "Enter configuration commands, one per line. End with CNTL/Z.", type: "output" },
  // { text: "Router(config)#interface fastethernet 0/0", type: "command" },
  // { text: "Router(config-if)#", type: "output" },
  // { text: "Router(config-if)#description router0 ifrange", type: "command" },
  // { text: "Router(config-if)#exit", type: "error" },
  // { text: "Router(config)#exit", type: "error" },
  // { text: "Router#", type: "output" },
]

export default function FlowBuilder() {
  const [showFlowList, setShowFlowList] = useState(true)
  const [selectedFlow, setSelectedFlow] = useState(null)
  const [nodes, setNodes, onNodesChange] = useNodesState([])
  const [edges, setEdges, onEdgesChange] = useEdgesState([])
  const [selectedNode, setSelectedNode] = useState(null)


  //to modal
  const [showPropertiesModal, setShowPropertiesModal] = useState(false)
  const [showConfigurationModal, setShowConfigurationModal] = useState(false)

  //Para el toast
  const [showToast, setShowToast] = useState(false)
  const [message, setMessage] = useState("")
  const [messageBody, setMessageBody] = useState("")
  const [bgColor, setBgColor] = useState("info")

  //Para el modal
  const [openModal, setOpenModal] = useState(false)
  const [steps, setSteps] = useState([])
  const [isComplete, setIsComplete] = useState(false)
  const [isSaving, setIsSaving] = useState(false);

  const [originalFlowSnapshot, setOriginalFlowSnapshot] = useState({ nodes: [], edges: [] });
  const [showSaveConfirm, setShowSaveConfirm] = useState(false);
  const [pendingSavePayload, setPendingSavePayload] = useState(null);
  const [pendingSaveDiff, setPendingSaveDiff] = useState(null);

  const dispatch = useDispatch()

  const processEdges = (edges) => {
    // Agrupar edges por source-target
    const edgeGroups = {};
    
    edges.forEach(edge => {
      const key = `${edge.source}-${edge.target}`;
      if (!edgeGroups[key]) {
        edgeGroups[key] = [];
      }
      edgeGroups[key].push(edge);
    });
    
    // Asignar índices a cada edge
    return edges.map(edge => {
      const key = `${edge.source}-${edge.target}`;
      const group = edgeGroups[key];
      const index = group.findIndex(e => e.id === edge.id);
      
      return {
        ...edge,
        data: {
          ...edge.data,
          index,
          total: group.length
        }
      };
    });
  };

  useEffect(() => {
    if (showFlowList){
      setSelectedFlow(null);
      setNodes([]);
      setEdges([]);
    }
  }
  , [showFlowList]);

  useEffect(() => {
  // Reprocesar edges cuando cambian los edges o nodos
  setEdges((eds) => processEdges(eds));
}, [edges.length]);


 const onConnect = useCallback(
  (params) => {
    const node = nodes.find((n) => n.id === params.source);
    var newEdge = params;
    
    if (node.type == "list" || node.type == "campaign") {
      const index = params.sourceHandle.split("-")[1];
      const label = node.data.options[index].title;
      newEdge = {
        ...params,
        type: "labeled",
        data: { label: label },
      }
      
      // ← AGREGAR: Actualizar connectedHandles del nodo
      setNodes((nds) =>
        nds.map((n) =>
          n.id === params.source
            ? {
                ...n,
                data: {
                  ...n.data,
                  connectedHandles: [...(n.data.connectedHandles || []), params.sourceHandle],
                },
              }
            : n
        )
      );
    }

    
    setEdges((eds) => {
      const updatedEdges = addEdge(newEdge, eds);
      return processEdges(updatedEdges);
    });
  },
  [setEdges, setNodes, nodes]
);

  const onEdgesDelete = useCallback(
  (edgesToDelete) => {
    setNodes((nds) =>
      nds.map((node) => {
        if (node.type === 'list' || node.type == "campaign") {
          // Filtra los handles conectados según los edges eliminados
          const updatedHandles = node.data.connectedHandles.filter(
            (handle) =>
              !edgesToDelete.some(
                (edge) => edge.sourceHandle === handle || edge.targetHandle === handle
              )
          );

          return {
            ...node,
            data: {
              ...node.data,
              connectedHandles: updatedHandles,
            },
          };
        }
        return node;
      })
    );
    
    // ← AGREGAR ESTO: Reprocesar los edges restantes
    setEdges((eds) => {
      const remainingEdges = eds.filter(
        (edge) => !edgesToDelete.some((deleted) => deleted.id === edge.id)
      );
      return processEdges(remainingEdges);
    });
  },
  [setNodes, setEdges]
);


  const handleFlowSelect = async (flow) => {
    // El listado de flows viene sin Content (se omite por tamaño). Si falta,
    // pedimos el detalle al backend para tener nodos/edges al editar.
    let flowToUse = flow;
    if (!flow.content && flow.id) {
      try {
        const detail = await dispatch(fetchFlowDetailFromAPI(flow.id));
        if (detail) {
          flowToUse = detail;
        }
      } catch (err) {
        console.error("No se pudo cargar el detalle del flow:", err);
      }
    }

    setSelectedFlow(flowToUse)
    setShowFlowList(false)
    var flowData = { nodes: [], edges: [] }

    if (flowToUse.content) {
      try {
        flowData = JSON.parse(flowToUse.content)
      } catch (e) {
        console.error("Error parseando content del flow:", e);
        flowData = { nodes: [], edges: [] };
      }
    }

    setNodes(flowData.nodes || [])
    setEdges(processEdges(flowData.edges || []))
    setOriginalFlowSnapshot({ nodes: flowData.nodes || [], edges: flowData.edges || [] });
  }

  // Carga un borrador generado por IA en el lienzo (reemplaza nodos/edges actuales).
  // El usuario lo revisa/edita y guarda con el flujo de guardado existente.
  const handleGeneratedFlow = (flowData, warnings) => {
    setNodes(flowData.nodes || []);
    setEdges(processEdges(flowData.edges || []));
    if (Array.isArray(warnings) && warnings.length > 0) {
      setShowToast(true);
      setBgColor("warning");
      setMessage("Flujo generado con avisos");
      setMessageBody(warnings.join(" "));
    } else {
      setShowToast(true);
      setBgColor("success");
      setMessage("Flujo generado");
      setMessageBody("Revisa y ajusta el borrador, luego guarda.");
    }
  };

  const handleNodeClick = (event, node) => {
    setSelectedNode(node);
    setShowPropertiesModal(true);
  };

  const handleCloseProperties = () => {
    setSelectedNode(null);
    setShowPropertiesModal(false);
  };

  const handleSave = async () => {
    if (isSaving) return;

    if (!selectedFlow) {
      setShowToast(true)
      setBgColor("danger")
      setMessage("Guardando Flujo")
      setMessageBody("No Hay Flujo Seleccionado")
      return;
    }

    const flowData = { nodes, edges };
    const diff = diffFlow(originalFlowSnapshot, flowData);

    setPendingSavePayload(flowData);
    setPendingSaveDiff(diff);
    setShowSaveConfirm(true);
  };

  const confirmSave = async () => {
    if (!selectedFlow || !pendingSavePayload) return;

    setShowSaveConfirm(false);
    setIsSaving(true);
    try {
      setShowToast(true)
      setBgColor("success")
      setMessage("Guardando Flujo")
      setMessageBody("Flujo Actualizado Correctamente")

      // 1) Guardar en messageflows
      await dispatch(updateFlowInAPI({
        id: selectedFlow.id,
        name: selectedFlow.name,
        businessLineId: selectedFlow.businessLineId,
        content: JSON.stringify(pendingSavePayload)
      }));

      // 2) Guardar versión en flowversion (si el endpoint existe)
      try {
        await dispatch(createFlowVersionInAPI({
          flowMessageId: selectedFlow.id,
          content: JSON.stringify(pendingSavePayload),
          name: selectedFlow.name,
        }));
      } catch (e) {
        // Si el backend aún no tiene el endpoint, no bloquear el guardado del flujo
        const status = e?.response?.status;
        if (status === 404) {
          setShowToast(true)
          setBgColor("warning")
          setMessage("FlowVersion")
          setMessageBody("No se pudo guardar la versión (endpoint no disponible)")
        } else {
          setShowToast(true)
          setBgColor("warning")
          setMessage("FlowVersion")
          setMessageBody("No se pudo guardar la versión del flujo")
        }
      }

      // Actualiza snapshot base para próximos diffs
      setOriginalFlowSnapshot({
        nodes: pendingSavePayload.nodes || [],
        edges: pendingSavePayload.edges || [],
      });
    } finally {
      setIsSaving(false);
      setPendingSavePayload(null);
      setPendingSaveDiff(null);
    }
  };

  const cancelSave = () => {
    setShowSaveConfirm(false);
    setPendingSavePayload(null);
    setPendingSaveDiff(null);
  };

  const copySelectedNode = () => {
    if (!selectedNode) return;

    const newId = `copy_${selectedNode.id}_${Date.now()}`;
    const newNode = {
      ...selectedNode,
      id: newId,
      position: {
        x: (selectedNode.position?.x || 0) + 40,
        y: (selectedNode.position?.y || 0) + 40,
      },
      data: {
        ...(selectedNode.data || {}),
      },
    };

    setNodes((prev) => [...prev, newNode]);
  };

  const handleOnCompile = () => {
    console.log("Compiling flow...")
    //setOpenModal(true)
    //setSteps([])
    dispatch(compileFlowAPI(selectedFlow.id));
    // if(selectedFlow) {
    //   const content = JSON.parse(selectedFlow.content)
    //   var stepText = "Se han encontrado "+ content.nodes.length+" Nodos y "+ content.edges.length +" Relaciones ¿Desea iniciar proceso de Compilación?"
    //   setSteps((prev) => [...prev, { text: "--- Compilacion de Flujo Seleccionado ---", type: "output" }])
    //   setSteps((prev) => [...prev, { text: stepText, type: "command" }])  
    // }

  }

  const openConfigModal = () => {
    setShowConfigurationModal(true)
  }

  const handleCloseConfigModal = () => {
    setShowConfigurationModal(false)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const handleDiscard = () => {
    setNodes([])
    setEdges([])
    handleCloseProperties()
  }

  const getStepColor = (type) => {
    switch (type) {
      case "command":
        return "#ffffff"
      case "success":
        return "#4caf50"
      case "error":
        return "#f44336"
      default:
        return "#9e9e9e"
    }
  }

  const processCompilation = (flowContent) => {
    const content = JSON.parse(flowContent)
    const nodos = content.nodes
    const relaciones = content.edges

    setTimeout(() => setSteps((prev) => [...prev, { text: "Revisando Nodos de Incio", type: "output" }]), 500)
    var starterNodes = nodos.filter((nodo) => nodo.type === "start")
    if (starterNodes.length == 0) {
      setTimeout(() => setSteps((prev) => [...prev, { text: "StarterNodes#ok", type: "success" }]), 1000)
    } else {
      setTimeout(() => setSteps((prev) => [...prev, { text: "StarterNodes#fail", type: "error" }]), 1000)
      return
    }

    setTimeout(() => setSteps((prev) => [...prev, { text: "Revisando Nodos de Cierre", type: "output" }]), 1500)
    var starterNodes = nodos.filter((nodo) => nodo.type === "end")
    if (starterNodes.length > 0) {
      setTimeout(() => setSteps((prev) => [...prev, { text: "StarterNodes#ok", type: "success" }]), 2000)
    } else {
      setTimeout(() => setSteps((prev) => [...prev, { text: "EndingNodes#fail", type: "error" }]), 2000)
      return
    }

    setTimeout(() => setSteps((prev) => [...prev, { text: "Revisando Nodos Aislados", type: "output" }]), 2500)
    var isolatedNodes = nodos.filter((nodo) => {
      const nodeId = nodo.id
      return !relaciones.some((relacion) => relacion.source == nodeId || relacion.target == nodeId)
    })




  }


  return (
    <div style={{ height: '85vh', display: 'flex' }}>
      {/* Left Sidebar */}
      <Box sx={{ width: 256, borderRight: 1, borderColor: 'divider', p: 2, display: 'flex', flexDirection: 'column' }}>
        {showFlowList ? (
          <FlowList onFlowSelect={handleFlowSelect} />
        ) : (
          <FlowActions
            selectedFlow={selectedFlow}
            setShowFlowList={setShowFlowList}
            handleOnCompile={handleOnCompile}
            onGenerateFlow={handleGeneratedFlow}
          />
        )}
      </Box>

      {/* Main Flow Area */}
      <div style={{ flex: 1, height: '100%' }}>
        <ReactFlowProvider>
          <Flow
            selectedFlow={selectedFlow}
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onEdgesDelete={onEdgesDelete}
            onConnect={onConnect}
            nodeTypes={nodeTypes}
            edgeTypes={edgeTypes}
            onNodeClick={handleNodeClick}
            setNodes={setNodes}
            setSelectedNode={setSelectedNode}
            handleSave={handleSave}
            handleDiscard={handleDiscard}
            openConfigModal={openConfigModal}
            isSaving={isSaving}
          />
        </ReactFlowProvider>
      </div>

      <Modal open={showPropertiesModal} onClose={handleCloseProperties}>
        <Box className="apple-modal" sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, height: 'auto', maxHeight: '90vh', bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">Propiedades</Typography>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Button variant="outlined" size="small" onClick={copySelectedNode} disabled={!selectedNode}>
                Copiar nodo
              </Button>
              <IconButton onClick={handleCloseProperties}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
          <Box sx={{ mt: 2, overflow: 'auto', maxHeight: '70vh' }}>
            <PropertiesPanel selectedNode={selectedNode} setNodes={setNodes} nodes={nodes} handleCloseProperties={handleCloseProperties} />
          </Box>
        </Box>
      </Modal>

      <FlowSaveConfirmModal
        open={showSaveConfirm}
        onClose={cancelSave}
        onConfirm={confirmSave}
        diff={pendingSaveDiff}
      />

      <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="terminal-modal">
        <TerminalPaper>
          <TerminalHeader>
            <Typography variant="h6" component="h2" sx={{ color: "#1a1b1e", fontSize: "1rem" }}>
              Compilación del flujo
            </Typography>
            <IconButton onClick={handleCloseModal} size="small" sx={{ color: "#1a1b1e", "&:hover": { color: "#fff" } }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </TerminalHeader>

          <TerminalContent>
            {steps.map((step, index) => (
              <Typography
                key={index}
                variant="body2"
                sx={{
                  color: getStepColor(step.type),
                  py: 0.5,
                  fontFamily: "inherit",
                  opacity: 0,
                  animation: "fadeIn 0.3s forwards",
                  "@keyframes fadeIn": {
                    "0%": {
                      opacity: 0,
                      transform: "translateY(5px)",
                    },
                    "100%": {
                      opacity: 1,
                      transform: "translateY(0)",
                    },
                  },
                }}
              >
                {step.text}
                {index === steps.length - 1 && !isComplete && (
                  <Box
                    component="span"
                    sx={{
                      display: "inline-block",
                      width: "8px",
                      height: "16px",
                      backgroundColor: "#fff",
                      marginLeft: "4px",
                      animation: "blink 1s infinite",
                      "@keyframes blink": {
                        "0%, 100%": {
                          opacity: 0,
                        },
                        "50%": {
                          opacity: 1,
                        },
                      },
                    }}
                  />
                )}
              </Typography>
            ))}
          </TerminalContent>

          <TerminalFooter>
            <Button
              onClick={() => processCompilation(selectedFlow.content)}
              variant="contained"
              size="medium"
            // sx={{
            //   backgroundColor: "#424242",
            //   "&:hover": { backgroundColor: "#616161" },
            // }}
            >
              Iniciar Compilar
            </Button>
          </TerminalFooter>
        </TerminalPaper>
      </Modal>

      <Modal open={showConfigurationModal} onClose={handleCloseConfigModal}>
        <Box className="apple-modal" sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, height: 'auto', maxHeight: '90vh', bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">Configuración del Flujo</Typography>
            <IconButton onClick={handleCloseConfigModal}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ mt: 2, overflow: 'auto', maxHeight: '70vh' }}>
            <ConfigurationPanel selectedFlow={selectedFlow} />
          </Box>
        </Box>
      </Modal>

    </div>
  )
}

